/*!
 * jQuery once adapted for cash-dom
 * If using jQuery, use jquery-once directly
 * http://github.com/robloach/jquery-once
 */

import jQuery from 'cash-dom';

/**
 * Ensures that the given ID is valid, returning 'once' if one is not given.
 */

const checkId = (id) => {
  const onceId = id || 'once';
  if (typeof onceId !== 'string') {
    throw new TypeError('The $.once() id parameter must be a string');
  }
  return `js-once-${onceId}`;
};

/**
 * Filter elements that have yet to be processed by the given data ID.
 */

// eslint-disable-next-line func-names
jQuery.fn.once = function (id) {
  const name = checkId(id);

  // Find elements that don't have the jQuery Once data applied to them yet
  // eslint-disable-next-line func-names
  return this.filter(function () {
    return jQuery(this).data(name) !== true;
  }).data(name, true);
};

/**
 * Removes the once data from elements, based on the given ID.
 */

// eslint-disable-next-line func-names
jQuery.fn.removeOnce = function (id) {
  // Filter through the elements to find the once'd elements.
  return this.findOnce(id).removeData(checkId(id));
};

/**
 * Filters elements that have already been processed once.
 */

// eslint-disable-next-line func-names
jQuery.fn.findOnce = function (id) {
  // Filter the elements by which do have the data.
  const name = checkId(id);

  // eslint-disable-next-line func-names
  return this.filter(function () {
    return jQuery(this).data(name) === true;
  });
};
